// all props here are from the "JW Player Configuration Reference"
// see https://developer.jwplayer.com/jw-player/docs/developer-guide/customization/configuration-reference/
const BASE_PROPS = {
  aspectratio: '16:9',
  displaydescription: false,
  displaytitle: false,
  width: '100%',
  height: 360,
  stretching: 'uniform',
  skin: {
    controlbar: {
      icons: '#ffffff',
      iconsActive: '#ffffff'
    }
  },
  preload: 'none'
};

const getProps = custom => ({ ...BASE_PROPS, ...custom });

// prettier-ignore
module.exports = {
  /**
   * this map handles mapping a `placement` (w/ optional `device`) to a config
   * object that will be used for the player.
   *
   * non-standard props passed are as follows:
   *
   * - `pid`: the player ID (*undocumented*). allows us to override the default
   *   pid value used by JW analytics, which is the player _library_ ID. the pid
   *   values specified here are the ids of the players created in the JW
   *   dashboard, which effectively allow us to track the usage of the players
   *   across our site.
   *
   * - `playerName`: how revops and the video teams reference the players in
   *   terms of ad targeting. the value here should mirror the player name in
   *   the JW dashboard. used only by our react components for GTM/GA tracking.
   *
   */
  JW_PLAYER_CONFIG: {
    default: {
      playerName: 'default',
      props: getProps({
        pid: 'GFssBFKn'
      }),
      showRelatedVideos: false
    },
    home: {
      playerName: 'home',
      props: getProps({
        pid: 'U5mCsDB7'
      }),
      showRelatedVideos: false
    },
    'in_post:mobile': {
      playerName: 'in-post',
      sticky: 'top',
      props: getProps({
        pid: 'Z3mML1JB'
      }),
      showRelatedVideos: true
    },
    'in_post:desktop': {
      playerName: 'in-post',
      sticky: 'bottom',
      props: getProps({
        pid: 'Z3mML1JB',
        mute: true,
        autostart: 'viewable'
      }),
      showRelatedVideos: true
    },
    right_rail: {
      playerName: 'right-rail',
      props: getProps({
        pid: '9EEDZlfQ',
        mute: true,
        autostart: 'viewable'
      }),
      showRelatedVideos: false
    },
    related: {
      playerName: 'related',
      props: getProps({
        pid: 'mG8Qonev',
        mute: true,
        autostart: 'viewable'
      }),
      showRelatedVideos: false
    }
  },

  JW_PLAYER_DESKTOP_BREAKPOINT: 1024,

  JW_PLAYER_AD_UNIT_PATHS: {
    default: '/6782/GenAptTherapy/Video',
    home: '/6782/GenAptTherapy/Video/Home',
    in_post: '/6782/GenAptTherapy/Video/InPost',
    right_rail: '/6782/GenAptTherapy/Video/Rail',
    related: '/6782/GenAptTherapy/Video/Related'
  },

  JW_PLAYER_AD_TAG_PARAMS: {
    sz: '400x300|640x480',
    impl: 's',
    gdfp_req: '1',
    env: 'vp',
    output: 'vast',
    unviewed_position_start: '1',
    url: '__referrer__',
    description_url: '__page-url__',
    correlator: '__timestamp__'
  },

  // related config is per "Configuring the Discovery Overlay"
  // see https://support.jwplayer.com/articles/how-to-enable-the-discovery-overlay
  JW_PLAYER_RELATED_PLAYLIST: {
    autoplaytimer: 10,
    onclick: 'play',
    oncomplete: 'autoplay',
    file:
      'https://content.jwplatform.com/feed.json?feed_id=DGnC74P2&related_media_id=MEDIAID'
  },

  // key is placement; value is id
  JW_AD_SCHEDULE_ID: {
    default: 'at000001',
    home: 'at000002',
    in_post: 'at000003',
    right_rail: 'at000004',
    related: 'at000005'
  },

  JW_DEFAULT_PLAYLIST_URL:
    'https://cdn.jwplayer.com/v2/playlists/YUB0cqVS?search=__CONTEXTUAL__',

  JW_AMP_PLAYER_ID: '9CWDU5Vg',
  JW_AMP_PLAYER_WITH_ADS_ID: 'e6jWpoWr',
  JW_AMP_RELATED_PLAYER_ID: 'oF0Q48yZ',

  // Our JW Showcase page
  VIDEO_HUB_URL: 'https://video.apartmenttherapy.com'
};
